import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.dx{justify-content:flex-end;}.ssr-plugin'
import '.r{overflow:hidden;}.ssr-plugin'
import '.a8{width:100%;}.ssr-plugin'
import { Style, styled } from 'inlines'
import useMediaQuery from '@app/util/useMediaQuery'
import { PropsWithChildren, useMemo } from 'react'
import { Image } from '@app/components/core/image/Image'

interface ImageDividerProps extends PropsWithChildren {
  src: string
  alt?: string
  style?: Style
  fullWidth?: boolean
}

export const ImageDivider = ({
  src,
  alt,
  children,
  style,
  fullWidth,
}: ImageDividerProps) => {
  const isMobile = useMediaQuery()
  const height = useMemo(
    () => style?.height ?? (isMobile ? '10rem' : '33.75rem'),
    [style?.height, isMobile],
  )

  return (
    <styled.div className="a b dx r a8"
      style={{
        height,
        borderRadius: fullWidth ? 0 : '1.25rem',
        position: fullWidth ? 'static' : 'relative',
        ...style,
      }}
    >
      <Image
        src={src}
        alt={alt}
        resizeWidth={isMobile ? 800 : 1920}
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          width: '100%',
          height,
          objectFit: 'cover',
        }}
      />

      {children}
    </styled.div>
  )
}
